import { Routes, Route, Navigate } from 'react-router-dom'
import Auth from './pages/Auth'
import Dashboard from './pages/Dashboard'
import PlayerView from './pages/PlayerView'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import ProtectedRoute from './components/ProtectedRoute'
import GMRoute from './components/GMRoute'
import Profile from './pages/Profile'
import Admin from './pages/Admin'
import JoinEvent from './pages/JoinEvent'
import Teams from './pages/Teams'
import OrgAdmin from './pages/OrgAdmin'
import CommandCenter from './pages/CommandCenter'
import OfflineBanner from './components/OfflineBanner'
import ThemeZone from './components/ThemeZone'
import BountyDetail from './pages/BountyDetail'
import FragoDetail from './pages/FragoDetail'
import EventDossiers from './pages/EventDossiers'
import EventAAR from './pages/EventAAR'
import Notifications from './pages/Notifications'
import EventPlaySheet from './pages/EventPlaySheet'
import ErrorBoundary from './components/ErrorBoundary'


function App() {
  return (
    <ErrorBoundary>
      <OfflineBanner />
        <ThemeZone>
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/join" element={<JoinEvent />} />
            {/* Single route — JoinEvent reads either params.code or params.token
                so legacy share links that still encode :token resolve fine. */}
            <Route path="/join/:code" element={<JoinEvent />} />
            <Route path="/dashboard" element={
              <GMRoute>
                <Dashboard />
              </GMRoute>
            } />
            <Route path="/play" element={
              <ProtectedRoute>
                <PlayerView />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/auth" replace />} />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <GMRoute platformOnly>
                <Admin />
              </GMRoute>
            } />
            <Route path="/teams" element={
              <ProtectedRoute>
                <Teams />
              </ProtectedRoute>
            } />
            <Route path="/org" element={
              <GMRoute>
                <OrgAdmin />
              </GMRoute>
            } />
            <Route path="/teams/:id" element={
              <ProtectedRoute>
                <CommandCenter />
              </ProtectedRoute>
            } />
            <Route path="/teams/:id" element={
              <ProtectedRoute>
                <CommandCenter />
              </ProtectedRoute>
            } />
            <Route path="/bounty/:id" element={
              <ProtectedRoute>
                <BountyDetail />
              </ProtectedRoute>
            } />
            <Route path="/frago/:id" element={
              <ProtectedRoute>
                <FragoDetail />
              </ProtectedRoute>
            } />
            <Route path="/event/:id/dossiers" element={
              <ProtectedRoute>
                <EventDossiers />
              </ProtectedRoute>
            } />
            <Route path="/event/:id/aar" element={
              <ProtectedRoute>
                <EventAAR />
              </ProtectedRoute>
            } />
            <Route path="/event/:id/playsheet" element={
              <ProtectedRoute>
                <EventPlaySheet />
              </ProtectedRoute>
            } />
            <Route path="/notifications" element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            } />
          </Routes>
        </ThemeZone>
    </ErrorBoundary>
  )
}

export default App